import {React} from 'react'
import {motion} from 'framer-motion'
import {LayoutTemplate} from 'lucide-react'
import {ChartNoAxesCombined,PanelTop,ChevronsLeftRightEllipsis } from 'lucide-react'

function ServicesComponent({icon,text,description}) {
    return (
        <motion.div initial={{opacity:0,y:50}} whileInView={{opacity:1,y:0}} transition={{duration:0.4}} whileHover={{y:-10}} className='flex flex-col gap-5 w-auto h-auto p-6 rounded-lg bg-[#0F0F23]'>
            <div className="div gap-4 flex items-center">
            <div className=' text-white'>
                {icon}
            </div>
            <h2 className='text-gray-300 text-[30px] max-md:text-[16px]'>
                {text}
            </h2>
            </div>
            <p className='text-white text-[16px] max-md:text-[14px]'>
                {description}
            </p>

        </motion.div>
    )
}

function Services() {
    return (
        <div className="div mt-20">
        <h1 className='text-center text-[60px] text-white font-bold'>Services</h1>
        <div className=" grid grid-cols-2 max-md:grid-cols-1 gap-8 text-white py-[50px]">
            <ServicesComponent icon=<LayoutTemplate size={40}/> text="Portfolio Websites" description="Design and develop modern, responsive portfolio websites that showcase your work and personal brand. "/>
            <ServicesComponent icon=<ChevronsLeftRightEllipsis size={40}/> text="Frontend Development" description="Develop fast, responsive, and modern websites using React, Tailwind CSS, and Framer Motion."/>
            <ServicesComponent icon=<ChartNoAxesCombined size={40} /> text="Data Analysis" description="Transform raw data into clear insights through cleaning, visualization, statistical analysis, and interactive dashboards."/>
            <ServicesComponent icon=<PanelTop size={40}/> text="Machine Learning" description="Build predictive machine learning models that help businesses forecast outcomes and make data-driven decisions."/>
        </div>
        </div>
    )
}
export default Services;